"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTypeRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.AccountTypeRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.account_type.label',
    fallbackLabel: 'Bank account type',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'IBAN', label: 'fields.enm.account_type.options.IBAN', fallbackLabel: 'IBAN' },
        { key: 'LOCAL_SE', label: 'fields.enm.account_type.options.LOCAL_SE', fallbackLabel: 'Local Sweden' },
        { key: 'LOCAL_US', label: 'fields.enm.account_type.options.LOCAL_US', fallbackLabel: 'Local USA' },
        { key: 'LOCAL_GENERIC', label: 'fields.enm.account_type.options.LOCAL_GENERIC', fallbackLabel: 'Local Norway/Denmark' },
        { key: 'SPECIAL', label: 'fields.enm.account_type.options.SPECIAL', fallbackLabel: 'Special' },
        { key: 'BANKGIRO', label: 'fields.enm.account_type.options.BANKGIRO', fallbackLabel: 'Local Sweden Bankgiro' },
        { key: 'PLUSGIRO', label: 'fields.enm.account_type.options.PLUSGIRO', fallbackLabel: 'Local Sweden Plusgiro' },
    ],
    trackFieldValueWithAnalytics: false,
};
